import AppLoading from "./loading-app.component";

export default AppLoading;
